module.exports = __webpack_public_path__ + "img/cloud-upload.12f9fd64.svg";